import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0f4e8606&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4e8606",
  null
  
)

export default component.exports